// extracted by mini-css-extract-plugin
export default {"token":"b1f50u","hover":"c1f50u","disabled":"d1f50u"};